import { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import { CheckFilled } from 'patternx-svg';

import './index.less';
import * as api from '@/services/enterprise';
import { downLoadPdf } from '@/components/pdf/CodeTemp';

const SuccessCreateAuCode = (props: any) => {
  const { handleCancel, auCodeInfo, data } = props;
  const [loading, setLoading] = useState(false);

  // 下载pdf
  const downloadPDF = () => {
    // console.log(props)
    const info = data.filter((item: any) => item.id === auCodeInfo.enterpriseWorkspaceId)[0];
    setLoading(true);
    downLoadPdf({
      codeList: auCodeInfo.authorizationCodes.map((item: any, index: number) => ({
        _index: index,
        ...item,
      })),
      phone: info.ownerPhone,
      authorize: info.companyName,
      cloud: info.name,
      project: auCodeInfo.authorizationCodes[0]?.projectApplications,
      person: info.ownerName,
      expiredDuration: auCodeInfo.authorizationCodes[0]?.expiredDuration,
    })
      .then((res) => {
        const filename = `${info.companyName}（${info.name}）授权码（${auCodeInfo?.authorizationCodes.length}个）.pdf`;
        downloadFile(res, filename);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const downloadFile = async (blob: Blob, filename: string) => {
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  return (
    <>
      <Modal title="创建授权码" visible={true} width={600} footer={null} onCancel={handleCancel}>
        <div>
          <CheckFilled
            style={{ width: '100%', height: '54px', color: 'rgba(94,180,113,1)', margin: '30px 0' }}
          />
          <div className="succMention">成功创建{auCodeInfo.num}个授权码</div>
          <div className="succMention2">确定无误后可点击下载将授权码生成PDF发送给用户</div>
        </div>
        <div className="buttonWrap">
          <Button onClick={handleCancel} style={{ marginRight: '12px' }}>
            返回列表
          </Button>
          <Button onClick={downloadPDF} type="primary" loading={loading}>
            下载PDF
          </Button>
        </div>
        <div
          style={{
            marginTop: '24px',
            background: '#f7f8fa',
            padding: '24px 40px',
            height: '280px',
            overflow: 'scroll',
          }}
        >
          <div>
            <div style={{ color: '#1d1d29', marginBottom: '16px' }}>授权码</div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {auCodeInfo.authorizationCodes.map((item: any, index: any) => (
                <div style={{ width: '50%', display: 'flex', marginBottom: '16px' }}>
                  <div
                    style={{
                      width: '26px',
                      textAlign: 'left',
                      lineHeight: '24px',
                      color: '#868b9c',
                    }}
                  >
                    {index + 1}
                  </div>
                  <div
                    style={{
                      background: 'rgba(225, 227, 232, 0.4)',
                      lineHeight: '20px',
                      padding: '2px 8px',
                    }}
                  >
                    {item.code}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SuccessCreateAuCode;
